export const messages = {
  en: {
    attrValue: {
      search: {
        title: 'Search Condition',
        valueId: 'valueId',
        specId: 'specId',
        value: 'value',
        valueName: 'valueName',
        valueShow: 'valueShow',
        createTime: 'createTime',
        placeholder: 'Please enter attrValue name'
      },
      list: {
        title: 'attrValue List'
      },
      dialog: {
        addTitle: 'Add AttrValue',
        editTitle: 'Edit AttrValue',
        delTitle: 'Delete AttrValue',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        valueId: 'valueId',
        specId: 'specId',
        value: 'value',
        valueName: 'valueName',
        valueShow: 'valueShow',
        createTime: 'createTime',
      },
      table: {
        valueId: 'valueId',
        specId: 'specId',
        value: 'value',
        valueName: 'valueName',
        valueShow: 'valueShow',
        createTime: 'createTime',
      },
      validate: {
        valueId: 'Please enter valueId',
        specId: 'Please enter specId',
        value: 'Please enter value',
        valueName: 'Please enter valueName',
        valueShow: 'Please enter valueShow',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add AttrValue success'
      },
      edit: {
        success: 'Edit AttrValue success'
      },
      delete: {
        success: 'Delete AttrValue success',
        confirm: 'Are you sure to delete this attrValue?'
      },
      fetchError: 'Failed to fetch attrValue list'
    }
  },
  zh: {
    attrValue: {
      search: {
        title: '查询条件',
        valueId: '值ID',
        specId: '规格ID',
        value: '值',
        valueName: '值名称',
        valueShow: '显示',
        createTime: '创建时间',
        placeholder: '请输入属性值名称'
      },
      list: {
        title: '属性值'
      },
      dialog: {
        addTitle: '添加属性值',
        editTitle: '编辑属性值',
        delTitle: '删除属性值',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        valueId: '值ID',
        specId: '规格ID',
        value: '值',
        valueName: '值名称',
        valueShow: '显示',
        createTime: '创建时间',
      },
      table: {
        valueId: '值ID',
        specId: '规格ID',
        value: '值',
        valueName: '值名称',
        valueShow: '显示',
        createTime: '创建时间',
      },
      validate: {
        valueId: '请输入值ID',
        specId: '请输入规格ID',
        value: '请输入值',
        valueName: '请输入值名称',
        valueShow: '请输入显示',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加属性值成功'
      },
      edit: {
        success: '编辑属性值成功'
      },
      delete: {
        success: '删除属性值成功',
        confirm: '确认删除该属性值吗？'
      },
      fetchError: '获取属性值列表失败'
    }
  }
}